import dayjs from 'dayjs';

/**
 * O evento já terminou: todas as datas dele ficaram para trás. É a mesma régua
 * do selo "Encerrado" (`is_past`, da API) — conta por dia, então o evento de
 * hoje ainda está ativo até a meia-noite. Sem datas, não dá para dizer que
 * acabou.
 *
 * Aceita o evento completo (traz `is_past`) ou o item da lista do painel (só
 * traz `dates`).
 */
export function hasEventEnded(event) {
    if (!event || typeof event !== 'object') return false;

    if (typeof event.is_past === 'boolean') return event.is_past;

    const days = (event.dates || [])
        .map(item => String(item?.date || '').slice(0, 10))
        .filter(Boolean);

    if (days.length === 0) return false;

    const today = dayjs().format('YYYY-MM-DD');

    return days.every(day => day < today);
}
